export default Object.freeze ({
    NO_DATA_FOUND : 'No Data Found !',
    NO_DATA_EXIST : 'There is no data.',
    IMAGE_TOO_LARGE : 'Image too large!',
    LOGIN_NOT_ALLOW : 'User is not allowed for mobile login.',
    IMAGE_MAX_FILE_SIZE : 4194304,
    IMAGE_MAX_SIZE_ERROR: 'Only maximun 4Mb imges size is allowed.',
    APPLICATION_URL : process.env.VUE_APP_URL,
    ENABLE_QR : {
        DISABLE : 0,
        ENABLE : 1
    },
    TEACHER_PARENT_CHAT : {
        DISABLE: 0,
        ENABLE : 1
    },
    ROLE : {
        ID: {
            ADMIN: 1,
            STAFF: 2,
            ACCOUNTANT: 4,
            LIBRARY_ADMIN: 5,
            OTHER: 3
        },
        TXT: {
            1 : 'Admin',
            2 : 'Staff',
            4 : 'Accountant',
            5 : 'Library Admin',
            3 : 'Other'
        }
    },
    CHAT_REQUEST_STATUS : {
        PENDING : 0,
        APPROVED : 1,
        REJECTED : 2
    },
    APPLICATION : {
        TYPE_TXT : {
            1 : "Parent",
            2 : "Student"
        },
        TYPE : {
            PARENT : 1,
            STUDENT : 2,
        },
        URL_PREFIX: "app-form",
    },

    ITEM_TYPES: {
        TYPE_TXT : {
            1: "Parent Item",
            2: "Student Item",
            3: "Additional Item",
        },
        TYPE : {
            PARENT : 1,
            STUDENT : 2,
            ADDITIONAL : 3,
        }
    },
    INPUT_TYPES: {
        1: 'Text',
        2: 'Textarea',
        3: 'Radio',
        4: 'Check Box',
        5: 'Select Box',
        6: 'File',
    },
    INPUT_TYPES_VAL: {
        TEXT: 1,
        TEXTAREA: 2,
        RADIO: 3,
        CHECKBOX: 4,
        SELECTBOX: 5,
        FILE: 6,
    },
    PARENT_REQUIRED: [
        'guardian1_name',
        'password',
        'phone1',
        'address',
    ],
    STUDENT_REQUIRED: [
        'name',
        'dob',
        'gender',
        'password',
        'religion',
        'class_id',
    ],
    STUDENT_ADDITIONAL_REQUIRED: [
        'phone1',
        'address',
    ],
    PAYMENT_STATUS : {
        STATUS_PARENT_ENROLL_REQUEST : 0,
        STATUS_APPROVED : 1,
        STATUS_DECLINED : 2,
        STATUS_ADMIN_REQUEST : 3
    },
    PAYMENT_STATUSES_OPTIONS : [
        { id: 0, text: "Request from Parent" },
        { id: 1, text: "Approve" },
        { id: 2, text: "Reject" },
        { id: 3, text: "Make Request to Parent" }
    ],
    NOTICE_STATUS : {
        UNSEND: 0,
        SEND: 1,
    },
    ADDITIONAL_STATUS: {
        OVERWRITE: 1,
        KEEP: 2,
        CREATE: 3
    },
    BOOK_TYPE: {
        1: 'Physical Book',
        2: 'Ebook'
    },
    BOOK_TYPE_VALUE: {
        'Physical Book': 1,
        'Ebook': 2
    },
    LIBRARY_MEMBER_STATUS:{
        1: 'Active',
        2: 'InActive',
        3: 'Block',
    },
    RETURN_STATUS: {
        'Yes': 1,
        'No': 0
    },

    FILE_NAME_MAX_FILE_SIZE:  5242880 ,

    FILE_NAME_MAX_SIZE_ERROR: 'File size exceeds the maximum allowed limit of 5MB.',

    BOOK_STATUS: {
        1: 'Damage',
        2: 'Loss',
    },

    ATTENDANCE_RATE_LIMIT: [
        { id: 0, text: 'All' },
        { id: 1, text: 'Below 75%' },
        { id: 2, text: '75% and above' },
    ],

    MESSAGE_TYPE: {
        TEXT: 1,
        IMAGE: 2,
        VIDEO: 4,
    },

    ROOM_TYPE: {
        DIRECT_CHAT: 1,
        GROUP_CHAT: 2,
    },

    AWS_URL: process.env.VUE_APP_AWS_URL,

    RELIGION : {
        1 : 'Buddhism',
        2 : 'Christianity',
        3 : 'Hinduism',
        4 : 'Islam',
        5 : 'Other'
    },

    NRC : {
        CITY : {
            1 : '၁',
            2 : '၂',
            3 : '၃',
            4 : '၄',
            5 : '၅',
            6 : '၆',
            7 : '၇',
            8 : '၈',
            9 : '၉',
            10 : '၁၀',
            11 : '၁၁',
            12 : '၁၂',
            13 : '၁၃',
            14 : '၁၄',
        },
        
        NAING : [
            "(နိုင်)",
            "(ဧည့်)",
            "(ပြု)"
        ],

        TOWNSHIP : {
            1 : [
                "ကမန",
                "ခဖန",
                "ခလဖ",
                "ခဘဒ",
                "ဆပဘ",
                "ဆလန",
                "တနန",
                "နမန",
                "ပတအ",
                "ဖကန",
                "ဗမန",
                "မကတ",
                "မကန",
                "မခဘ",
                "မစန",
                "မညန",
                "မမန",
                "ရကန",
                "ဝမန",
                "အဂယ"
            ],
            2 : [
                "ဒမဆ",
                "ဖဆန",
                "ဖရဆ",
                "ဘလခ",
                "မစန",
                "ရတန",
                "ရသန",
                "လကန"
            ],
            3 : [
                "ကကရ",
                "ကဆက",
                "ဖပန",
                "ဘအန",
                "မဝတ",
                "လဘန",
                "သတန"
            ],
            4 : [
                "ကပလ",
                "တဇန",
                "တတန",
                "ပလဝ",
                "ဖလန",
                "မတန",
                "မတပ",
                "ထတလ",
                "ဟခန"
            ],
            5 : [
                "ကနန",
                "ကဘလ",
                "ကလန",
                "ကလတ",
                "ကလထ",
                "ကလဝ",
                "ကသန",
                "ခနတ",
                "ခတန",
                "ခဥန",
                "စကန",
                "ဆလက",
                "တဆန",
                "တမန",
                "ထခန",
                "ဒပယ",
                "နယန",
                "ပလန",
                "ပလဘ",
                "ဖပန",
                "ဗမန",
                "ဘတလ",
                "မကန",
                "မမတ",
                "မမန",
                "မရန",
                "မလန",
                "ယမပ",
                "ရဘန",
                "ရဥန",
                "လရန",
                "လဟန",
                "ဝလန",
                "ဝသန",
                "ဟမလ",
                "အတန",
                "အရတ"
            ],
            6 : [
                "ကသန",
                "ကစန",
                "ထဝန",
                "ပလန",
                "ဘပန",
                "မမန",
                "ရဖန",
                "လလန",
                "သရခ",
                "တသရ"
            ],
            7 : [
                "ကကန",
                "ကတခ",
                "ကပက",
                "ကဝန",
                "ဇကန",
                "ညလပ",
                "တငန",
                "ထတပ",
                "ဒဥန",
                "နတလ",
                "ပခန",
                "ပတန",
                "ပမန",
                "ဖမန",
                "မညန",
                "မလန",
                "ရတရ",
                "ရကန",
                "ရတန",
                "လပတ",
                "ဝမန",
                "သကန",
                "သတန",
                "သနပ",
                "သဝတ",
                "အဖန",
                "အတန"
            ],
            8 : [
                "ကမန",
                "ခမန",
                "ဂဂန",
                "ငဖန",
                "စတရ",
                "စလန",
                "ဆပဝ",
                "ဆဖန",
                "ဆမန",
                "တတက",
                "ထလန",
                "နမန",
                "ပခက",
                "ပဖန",
                "ပမန",
                "မကန",
                "မတန",
                "မဘန",
                "မမန",
                "မလန",
                "မသန",
                "ရစက",
                "ရနခ",
                "သရန",
                "အလန"
            ],
            9 : [
                "ကဆန",
                "ကပတ",
                "ခမစ",
                "ခအဇ",
                "ငဇန",
                "စကန",
                "ဇဗသ",
                "ဇယသ",
                "ညဥန",
                "တကန",
                "တတဥ",
                "တသန",
                "ဒခဏ",
                "နထက",
                "ပကခ",
                "ပဗသ",
                "ပဘန",
                "ပမန",
                "ပသက",
                "ပဥလ",
                "မကန",
                "မခန",
                "မတရ",
                "မတလ",
                "မထလ",
                "မမန",
                "မရမ",
                "မရန",
                "မရတ",
                "မလန",
                "မသန",
                "မဟမ",
                "ရမသ",
                "လဝန",
                "ဝတန",
                "သစန",
                "သပက",
                "အမဇ",
                "အမရ",
                "ဥတရ"
            ],
            10 : [
                "ကမရ",
                "ကထန",
                "ခဆန",
                "ပမန",
                "ဘလန",
                "မဒန",
                "မလမ",
                "ရမန",
                "သထန",
                "သဖရ"
            ],
            11 : [
                "ကဖန",
                "ကတန",
                "ဂမန",
                "စတန",
                "တကန",
                "ပဏက",
                "ပတန",
                "ဘသတ",
                "မတန",
                "မပန",
                "မပတ",
                "မအန",
                "မဥန",
                "ရဗန",
                "ရသတ",
                "သတန",
                "အမန"
            ],
            12 : [
                "ကကက",
                "ကခက",
                "ကတတ",
                "ကတန",
                "ကမတ",
                "ကမန",
                "ကမရ",
                "ခရန",
                "စခန",
                "ဆကခ",
                "ဆကန",
                "တကန",
                "တတန",
                "ထတပ",
                "တမန",
                "ဒဂဆ",
                "ဒဂတ",
                "ဒဂန",
                "ဒဂမ",
                "ဒဂရ",
                "ဒပန",
                "ဒလန",
                "ပဇတ",
                "ပဘတ",
                "ဗတထ",
                "ဗဟန",
                "မဂတ",
                "မဂဒ",
                "မဘန",
                "မရက",
                "ရကန",
                "ရပသ",
                "လကန",
                "လမတ",
                "လမန",
                "လသန",
                "လသယ",
                "သကတ",
                "သခန",
                "သဃက",
                "သလန",
                "အစန",
                "အလန",
                "ဥကတ",
                "ဥကမ"
            ],
            13 : [
                "ကဟန",
                "ကကန",
                "ကခန",
                "ကတန",
                "ကမန",
                "ကသန",
                "ကလန",
                "ကတက",
                "ခရဟ",
                "ဆဆန",
                "ညရန",
                "တကန",
                "တခလ",
                "တယန",
                "တတန",
                "တမည",
                "တလန",
                "နဆန",
                "နမတ",
                "နခန",
                "နခတ",
                "နဖန",
                "နစန",
                "နတရ",
                "နတန",
                "ပတယ",
                "ပပက",
                "ပလန",
                "ပဆန",
                "ပဝန",
                "ပလန",
                "ပယန",
                "ဖခန",
                "မကန",
                "မမတ",
                "မခန",
                "မငန",
                "မဆန",
                "မတန",
                "မပတ",
                "မနန",
                "မပန",
                "မဖန",
                "မဘန",
                "မမန",
                "မယန",
                "မရန",
                "မလန",
                "မဟရ",
                "ရငန",
                "ရစန",
                "ရညန",
                "လကန",
                "လခန",
                "လရန",
                "လလန",
                "သနန",
                "သပန",
                "ဟပန",
                "ဟမန",
                "အတန",
                "အပန",
                "အသယ"
            ],
            14 : [
                "ကကထ",
                "ကကန",
                "ကခန",
                "ကပန",
                "ကလန",
                "ငဆန",
                "ငပတ",
                "ငသခ",
                "ဇလန",
                "ညတန",
                "ဒဒရ",
                "ဓနဖ",
                "ပတန",
                "ပသန",
                "ဖပန",
                "ဘကလ",
                "မအပ",
                "မမက",
                "မမန",
                "မအန",
                "ရကန",
                "လပတ",
                "လမန",
                "ဝခမ",
                "ဟသတ",
                "သပန",
                "အဂပ",
                "အမန"
            ]
        }
    },

    TRANSACTION_TYPE: {
        income: 1,
        expense: 2
    },

    ATTENDANCE_STATUS_COLOR: {
      0: 'bg-danger',  // Absent
      1: 'bg-success', // Present
      2: 'bg-warning', // Late
      default: 'bg-gray',
    },
})
